import React, {Fragment, useState} from "react";
import CommonHeader from "../../components/Headers/CommonHeader";
import SafeView from "../../components/safeView/SafeView";
import ProtectedContent from "../../components/protectedContent";
import CustomFieldChoicesModal from "./customFieldChoicesModal";
import CustomFieldChoicesTable from "./customFieldChoicesTable";

const CustomFieldChoices = () => {
  const [modalStatus, setModalStatus] = useState(false);

  return (
    <SafeView>
      <ProtectedContent perms={["view_customfieldchoiceset"]} showFallback>
        <Fragment>
          {modalStatus && (
            <CustomFieldChoicesModal
              open={modalStatus}
              onCancel={() => setModalStatus(false)}
            />
          )}
          <ProtectedContent perms={["add_customfieldchoiceset"]}>
            <CommonHeader
              content={"Add Custom Field Choice"}
              handleAddClick={() => setModalStatus(true)}
              testID={"add_custom_field_choice"}
            />
          </ProtectedContent>
          <CustomFieldChoicesTable />
        </Fragment>
      </ProtectedContent>
    </SafeView>
  );
};

export default CustomFieldChoices;
